export default __webpack_public_path__ + "static/media/online-test.613db2c2.svg";